import {IActionDispatcher, ILayersDispatcher, IPaylodAction} from '../interfaces/dispatchers'

import LayerInfosActions from '../enums/ActionTypes/LayerInfosActions'
import {IFeatureLayerInfo, IHiddenGroupCaches} from '../interfaces/models'
import {IStore} from '../interfaces/reducers'
import {ImageLayer, ImageWMS, TileLayer, TileWMS, VectorSource} from '../models'

export class LayersDispatcher implements ILayersDispatcher {
  constructor() {
    this.changeVisibleLayers = this.changeVisibleLayers.bind(this)
    this.setHiddenGroupCaches = this.setHiddenGroupCaches.bind(this)
  }

  public setHiddenGroupCaches(hiddenGroupCaches: IHiddenGroupCaches) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      const featureLayerInfos = store.layerInfos.featureLayerInfos
      const currentlyHidden = {...store.layerInfos.hiddenGroupsCaches}
      const removes: IFeatureLayerInfo[] = []
      const newlyAdded: IHiddenGroupCaches = {}
      const newlyUpdated: IHiddenGroupCaches = {}
      for (const g in hiddenGroupCaches) {
        if (!currentlyHidden[g]) {
          newlyAdded[g] = {}
        } else {
          newlyUpdated[g] = hiddenGroupCaches[g]
        }
      }
      for (const id in featureLayerInfos) {
        if (newlyAdded[featureLayerInfos[id].sourceDescription.group]) {
          ;[featureLayerInfos[id].vectorLayer, featureLayerInfos[id].imageLayer].forEach(layer => {
            if (layer && layer.getVisible()) {
              newlyAdded[featureLayerInfos[id].sourceDescription.group][id] = id
              removes.push(featureLayerInfos[id])
            }
          })
        }
      }

      // Handle newly removed and now visible groups
      const adds: IFeatureLayerInfo[] = []
      const newlyRemoved: IHiddenGroupCaches = {}
      for (const id in currentlyHidden) {
        if (!newlyUpdated[id]) {
          newlyRemoved[id] = currentlyHidden[id]
        }
      }
      for (const key in newlyRemoved) {
        for (const id in newlyRemoved[key]) {
          if (featureLayerInfos[id]) {
            adds.push(featureLayerInfos[id])
          }
        }
      }

      if (removes.length > 0 || adds.length > 0) {
        dispatch(this.changeVisibleLayers(adds, removes))
      }
      dispatch({
        type: LayerInfosActions.SET_HIDDEN_GROUP_CACHE,
        payload: {...newlyAdded, ...newlyUpdated}
      })
    }
  }

  public setLoadingLayer(id: string, loading: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const loadingLayers = {...getStore().layerInfos.loadingLayers}
      if (loading) {
        loadingLayers[id] = true
      } else {
        delete loadingLayers[id]
      }
      dispatch({
        type: LayerInfosActions.SET_LOADING_LAYERS,
        payload: loadingLayers
      })
    }
  }

  public changeVisibleLayers(add: IFeatureLayerInfo[], remove: IFeatureLayerInfo[]) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      const store = getStore()
      const layerInfos = store.layerInfos
      const visibleLayers = layerInfos.visibleLayers

      remove.forEach(f => {
        add = add.filter(r => r.url != f.url)
        ;[f.vectorLayer, f.imageLayer]
          .filter(l => !!l)
          .forEach(l => {
            delete visibleLayers[f.url]
            const source = l.getSource()
            if (source instanceof VectorSource) {
              l.setVisible(false)
            } else if (source instanceof TileWMS || source instanceof ImageWMS) {
              let params = (source as TileWMS | ImageWMS).getParams()
              const currentlyVisible = params['LAYERS'].split(',') as string[]
              const index = currentlyVisible.indexOf(f.sourceDescription.layerName.toString())
              if (index != -1) {
                currentlyVisible.splice(index, 1)
              }
              if (currentlyVisible.length == 0) {
                l.setVisible(false)
              } else {
                params = {...params, LAYERS: currentlyVisible.join(','), time: Date.now()}
                ;(l as any).getSource().updateParams(params)
              }
            }
          })
      })
      add.forEach(f => {
        ;[f.vectorLayer, f.imageLayer]
          .filter(l => !!l)
          .forEach(l => {
            visibleLayers[f.url] = {}
            const source = l.getSource()
            if (l.moreInfo.urls.length > 0 && (l instanceof TileLayer || l instanceof ImageLayer)) {
              if (source instanceof TileWMS || source instanceof ImageWMS) {
                let params = (source as TileWMS | ImageWMS).getParams()
                let currentlyVisible = (params['LAYERS'].split(',') as string[]).filter(l => !!l)
                if (!l.getVisible()) {
                  currentlyVisible = []
                }
                const index = currentlyVisible.indexOf(f.sourceDescription.layerName.toString())
                if (index == -1) {
                  currentlyVisible.push(f.sourceDescription.layerName.toString())

                  params = {...params, LAYERS: currentlyVisible.join(','), time: Date.now()}
                  ;(l as any).getSource().updateParams(params)
                }
              }
            }
            l.setVisible(true)
          })
      })

      dispatch({
        type: LayerInfosActions.SET_VISIBLE_LAYERS,
        payload: visibleLayers
      })
    }
  }
}
